


































































import {EntityService} from "@/services/entity.service";
import Vue from "vue";
import Edit from './Edit.vue'
import {mapState} from "vuex";
const entityService = new EntityService()

export default Vue.extend({
	name: 'List',
	components: { Edit },
	data: () => ({
		isLoading: false,
		entity: 'instrumentos',
		search: '',
		listData: [],
		headers: [
			{ text: 'ID', value: 'id' },
			{ text: 'UUID', value: 'uuid' },
			{ text: 'Imagen', value: 'imagen' },
			{ text: 'Título', value: 'titulo' },
			{ text: 'Descripción', value: 'descripcion' },
			{ text: '', value: 'actions' }
		],
		showModalEdit: false,
		selectedResult: '',
		editEntity: {}
	}),
	async created() {
		this.loadData()
	},
	computed: {
		...mapState(["user"])
	},
	methods: {
		async loadData() {
			this.isLoading = true
			this.listData = await entityService.getList(this.entity)
			this.isLoading = false
		},
		editEntityAction (entity: object) {
			this.editEntity = entity
			this.showModalEdit = true
		}
	},
	watch: {
		showModalEdit (value) {
			if (!value) this.loadData()
		}
	}
})
